import { Box, Flex, FormControl, FormErrorMessage, FormHelperText, FormLabel, Select, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContractRisk } from "../../../../../../autogen/bff-api";
import { useAppDispatch } from "../../../../../../common/redux/hooks";
import { containsError } from "../../../../../../common/redux/reducers/contractReducer";
import { editContractThunk } from "../../../../../../common/redux/thunks/contract/edit-contract-thunk";
import { useTranslationTools } from "../../../../../../common/useTranslationTools";
import { useContractState } from "../../../useContractState";
import { RemoveDataFieldButton } from "../RemoveDataFieldButton";

interface Props {
  removeDataField?: () => Promise<void>;
  isRequiredButNotProvided: boolean;
}

export const Risk = ({ removeDataField, isRequiredButNotProvided }: Props) => {
  const { t } = useTranslation();
  const contractState = useContractState();
  const [isLoading, setIsLoading] = useState(false);
  const errorMessage = containsError(contractState, "EditRisk") ? t("Update failed") : null;
  const dispatch = useAppDispatch();
  const [risk, setRisk] = useState<string>();
  const translationTools = useTranslationTools();
  const options = [
    ContractRisk.VeryHigh,
    ContractRisk.AboveAverage,
    ContractRisk.Average,
    ContractRisk.BelowAverage,
    ContractRisk.VeryLow,
  ];

  useEffect(() => {
    if (contractState.contract.dataFields?.risk) {
      setRisk(contractState.contract.dataFields.risk);
    }
  }, []);

  const eventHandler = async (value: ContractRisk) => {
    setIsLoading(true);
    await dispatch(
      editContractThunk({
        command: {
          type: "EditRisk",
          value: value,
        },
      })
    );
    setIsLoading(false);
  };
  return (
    <FormControl isInvalid={errorMessage !== null} isRequired={isRequiredButNotProvided}>
      <FormLabel htmlFor={"value"}>
        {t("Contract risk level")} {isLoading && <Spinner size="xs" />}
      </FormLabel>
      <Flex w="100%">
        <Box borderRadius={"10px"} backgroundColor="smBackground" w="100%">
          <Select
            value={risk}
            onChange={(e) => {
              setRisk(e.target.value as ContractRisk);
              eventHandler(e.target.value as ContractRisk);
            }}
          >
            {options.map((e) => (
              <option key={e} value={e}>
                {translationTools.getRiskTranslation(e)}
              </option>
            ))}
          </Select>
        </Box>
        <RemoveDataFieldButton removeDataField={removeDataField} />
      </Flex>
      <FormHelperText>{t("Provide the risk level for this contract")}</FormHelperText>
      <FormErrorMessage>{errorMessage && errorMessage}</FormErrorMessage>
    </FormControl>
  );
};
